
export const formatTime = (time) => {
    return new Date(`1970-01-01T${time}:00`).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

function timeToMinutes(timeStr) {

  if(timeStr){
    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + minutes;
  }

}

export function getTimeSlotKey(timeStr,timeSlotGroups) {
  const minutes = timeToMinutes(timeStr);

  for (const key in timeSlotGroups) {
    const { start, end } = timeSlotGroups[key];
    if (minutes >= start && minutes < end) {
      return key;
    }
  }

  return null; // return null if it doesn't match any slot
}

export function getFullDayName(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { weekday: 'long' }); // returns "Thursday"
}

export function generateTimeSlots(operationDay) {
  const slots = [];
  const [fromHour, fromMinute] = operationDay.from.split(':').map(Number);
  const [toHour, toMinute] = operationDay.to.split(':').map(Number);

  let start = new Date();
  start.setHours(fromHour, fromMinute, 0, 0);

  const end = new Date();
  end.setHours(toHour, toMinute, 0, 0);

  while (start < end) {
    const hours = String(start.getHours()).padStart(2, '0');
    const minutes = String(start.getMinutes()).padStart(2, '0');
    slots.push(`${hours}:${minutes}`);
    start.setMinutes(start.getMinutes() + 30);
  }

  return slots;
}

export const addMinutesToTime = (timeStr, minutesToAdd) => {
  const [hour, minute] = timeStr.split(":").map(Number);
  const date = new Date();
  date.setHours(hour);
  date.setMinutes(minute + minutesToAdd);

  const newHour = String(date.getHours()).padStart(2, "0");
  const newMinute = String(date.getMinutes()).padStart(2, "0");

  return `${newHour}:${newMinute}`;
};


export const roundToNextSlot = (isoString) => {
  if (!isoString) return false;

  const date = new Date(isoString);
  if (isNaN(date.getTime())) return false; // invalid date check

  const minutes = date.getMinutes();

  if (minutes === 0) {
    date.setSeconds(0);
    date.setMilliseconds(0);
  } else if (minutes <= 30) {
    date.setMinutes(30);
    date.setSeconds(0);
    date.setMilliseconds(0);
  } else {
    date.setHours(date.getHours() + 1);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
  }

  const hours = String(date.getHours()).padStart(2, "0");
  const mins = String(date.getMinutes()).padStart(2, "0");

  return `${hours}:${mins}`;
};


export const combineDateAndTimeToISO = (year, month, date, timeStr) => {
  if (!timeStr) return false;

  const [hours, minutes] = timeStr.split(":").map(Number);
  const combinedDate = new Date(year, month, date, hours, minutes, 0);
  const pad = (n) => String(n).padStart(2, '0');

  const formatted = `${combinedDate.getFullYear()}-${pad(combinedDate.getMonth() + 1)}-${pad(combinedDate.getDate())}T${pad(combinedDate.getHours())}:${pad(combinedDate.getMinutes())}:${pad(combinedDate.getSeconds())}.000`;

  return formatted;
};

export function convertMinutesTo24HourTime(minutes) {
  const totalMinutes = minutes % (24 * 60); // Wrap around 24h if needed
  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;

  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = mins.toString().padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}`;
}